<template>
    <div class="table_wrap">
        <el-table class="list-table" header-cell-class-name="list-header"
                  style="width: 100%;" height="695" empty-text="데이터가 없습니다."
                  :data="itemData"
        >
            <el-table-column
                class="table_no"
                type="index"
                label="No"
                width="90"
                class-name="num text-center"
                :index="tableIdx"
            >
            </el-table-column>
            <el-table-column label="의뢰번호" width="" class-name="text-center" prop="l_uuid"></el-table-column>
            <el-table-column label="아이디" width="" class-name="text-center" prop="mb_id"></el-table-column>
            <el-table-column label="닉네임" width="" class-name="text-center" prop="mb_nick"></el-table-column>
            <el-table-column label="이름" width="" class-name="text-center" prop="mb_name"></el-table-column>
            <el-table-column label="상태" width="" class-name="text-center">
                <template slot-scope="scope">
                    <span>{{ returnDetectionStatus(scope.row.l_status) }}</span>
                </template>
            </el-table-column>
            <el-table-column label="의뢰일" width="" class-name="text-center" prop="c_end_time">
                <template slot-scope="scope">
                    <span>
                        {{ returnDateFormat(scope.row.created_at, 'YYYY-MM-DD HH:mm') }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column label="보상금(원)" width="" class-name="text-center" >
                <template slot-scope="scope">
                    <span>{{ returnCommas(scope.row.l_price) }}</span>
                </template>
            </el-table-column>

            <el-table-column
                label="옵션" width="" class-name="text-center">
                <template slot-scope="scope">
                    <div class="row-info ">
<!--                        <div class="row-info pointer" @click="moveDetail(scope.row.l_idx)">
                            [상세]
                        </div>-->
                        <el-button class="com_btn"  @click="moveDetail(scope.row.l_idx)">
                            상세
                        </el-button>
                    </div>
                </template>
            </el-table-column>
        </el-table>
    </div>

</template>

<script>
import dateMixins from "@/mixins/dateMixins";
import {detectionStatus} from "@/service/itemService";
import util from "@/mixins/util";

export default {
  name: "ItemListDetectionLayout",
  mixins: [dateMixins],
  components: {
  },
  inject: [],
  provide() {
    return{

    }
  },
  props: {
      itemData: {
          type: Array,
          default: () => {
              return []
          }
      },
      paginationData: {
          type: Object,
          default: () => {
              return {
                  total: 0,
                  page: 0,
                  size: 0,
              }
          }
      },
  },
  data() {
    return{
        detectionStatus:detectionStatus
    }
  },
  beforeRouterEnter() {},
  created() {
  },
  mounted() {

  },
  beforeDestroy() {
  },
  destroyed() {},
  computed: {
  },
  methods:{
      moveDetail(idx) {
          this.$router.push(`/item/detection/request/${idx}`);
      },
      tableIdx(index) {
          return this.paginationData.total - index - (this.paginationData.page - 1) * this.paginationData.size;
      },
      returnDetectionStatus(value){
          let keys = Object.keys(this.detectionStatus)
          let key = keys.filter(status => Number(status) === value);
          if(util.isEmpty(key)){
              return '-'
          }
          return this.detectionStatus[key].name
      },
      returnCommas(x = 0) {
          if(util.isEmpty(x)){
              return '-'
          }
          return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      },
  },
  watch: {

  },
}
</script>

<style scoped>

</style>
